import { useEffect, useState } from "react"
import * as Pusher from "pusher-js";
import logo from './assets/logo.svg'
import { Waves } from './Lobby'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/theme-monokai'
import 'ace-builds/src-noconflict/ext-language_tools'
import 'ace-builds/src-noconflict/ext-beautify'
import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/mode-java'
import 'ace-builds/src-noconflict/mode-xml'
import 'ace-builds/src-noconflict/mode-c_cpp'
import 'ace-builds/src-noconflict/mode-html'
import 'ace-builds/src-noconflict/mode-kotlin'
import 'ace-builds/src-noconflict/mode-ruby'
import 'ace-builds/src-noconflict/mode-sass'
import 'ace-builds/src-noconflict/mode-css'
import 'ace-builds/src-noconflict/mode-php'
import 'ace-builds/src-noconflict/mode-python'
import 'ace-builds/src-noconflict/mode-django'
import 'ace-builds/src-noconflict/mode-typescript'

const Lobby = ({ ID }) => {

  const [channel, setChannel] = useState("")
  const [codeValue, setCodeValue] = useState("");
  const [language, setLanguage] = useState("javascript");

  useEffect(() => {
    setChannel(joinLobby(ID));
  }, [])

  // TODO, UPDATE DUCKS WHEN SOMEONE LEAVES


  // const [code, setCode] = useState("")

  // script that starts Pusher instance
  function joinLobby(lobbyID) {

    // pusher config stuff
    Pusher.logToConsole = true;
    const pusher = new Pusher("afa35c87c2b8ba97d58d", {
        cluster: "us3",
        encrypted: true,
        authEndpoint: 'https://quackoverflow2022.herokuapp.com/pusher/auth'
    });

    var channel = pusher.subscribe("presence-" + lobbyID);

    // when joining the lobby, update your code value to what you recieve
    channel.bind("client-code-send", (data) => {
      setCodeValue(data.message);
    })


    //event recieved from someone else joining lobby
    
    channel.bind("client-join", (data) => {      
      let lobbyList = document.getElementById("ducksCount");
      lobbyList.textContent = channel.members.count + " Ducks are here.";
    });

    // event recieved from code request from new duck

    channel.bind("client-code-request", (data) => {
      channel.trigger("client-code-send", {
        message: codeValue
      })
    })


    // event recieved from code change

    channel.bind("client-code-change", (data) => {
      setCodeValue(data.message);
    })


    // event sent from self joining lobby
    channel.bind("pusher:subscription_succeeded", () => {
      let welcomeMessage = channel.trigger("client-join", {
          message: "Welcome!"
      });

      console.log("new Duck joined!");
      

      if (codeValue == ""){
        let codeRequest = channel.trigger("client-code-request", {
          message: "pls"
        })
      }

      let lobbyList = document.getElementById("ducksCount");      
      lobbyList.textContent = channel.members.count + " Ducks are here.";  

    });

    channel.bind("client-send-text", (data) => {

      let text = document.createElement("p");
      text.textContent = data.message;
      text.style.color = "#FF7E1F";

      document.querySelector(".textMessages").appendChild(text);
    })

    // when user leaves channel
    channel.bind("pusher:member_removed", (member) => {
      let lobbyList = document.getElementById("ducksCount");      
      lobbyList.textContent = channel.members.count + " Ducks are here.";  
    });



    // all client messages must start with -client
    return channel;
  }

  function codeChange(event){
    channel.trigger("client-code-change", {
      message: event
    });

  }

  // send text message
  function sendText(text){
    channel.trigger("client-send-text", {
      message: text
    })
  }

  return <div className="Pond">
    <header>
      <img className='logo' src={logo} alt="Logo" />
      <div className="info">
        <p className="coordinates">Pond Coordinates: {ID}</p>
        <p id="ducksCount"></p>
      </div>
    </header>
      {/* <div id="lobbyList"></div> */}
      <Waves/>
      <main>

      <div className="editorBox">
        <div className="select">
          <select onChange={(e) => setLanguage(e.target.value) }>
            <option value='html'>HTML</option>
            <option value='xml'>XML</option>
            <option value='css'>CSS</option>
            <option value='sass'>Sass</option>
            <option value='javascript'>JavaScript</option>
            <option value='typescript'>TypeScript</option>
            <option value='python'>Python</option>
            <option value='django'>Django</option>
            <option value='java'>Java</option>
            <option value='kotlin'>Kotlin</option>
            <option value='c_cpp'>C/C++</option>
            <option value='ruby'>Ruby</option>
            <option value='php'>PHP</option>
          </select>
        </div>
        <AceEditor 
          style={{
            width: '45vw',
            height: '65vh',
            borderRadius: '0.5rem'
          }}
          name='editor'
          theme='monokai'

          onChange={codeChange}
          mode={language}

          fontSize={18}
          showPrintMargin={true}
          showGutter={true}
          highlightActiveLine={true}
          value={codeValue}
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            showLineNumbers: true,
            tabSize: 4,
          }}
        />
        </div>

        <div className="chatBox">
          
          <div className="textMessages">
            
          </div>

          <div className="input">
            <input id="textMessage" type="text" placeholder='Message' required/>
          </div>
          
          <button onClick={
            () => {
              let text = document.getElementById("textMessage").value;
              sendText(text);
              let textHTML = document.createElement("p");
              textHTML.textContent = text;
              textHTML.style.color = "#4BE9FF";

              let textHolder = document.querySelector(".textMessages");
              textHTML.textContent = "You: " + textHTML.textContent;
              textHolder.appendChild(textHTML);
              text.value = "";
            }
          }id="popupButton" type="button" className="btn btn-secondary">Send!</button>

        </div>



      </main>
  </div>
}

export default Lobby